import { Component, OnInit } from '@angular/core';
import { ParEmployeeService } from '../../services/par_employees/par_employees.service';
import { Router, RoutesRecognized, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-paremployee-navtab',
  templateUrl: './paremployee-navtab.component.html',
  styleUrls: ['./paremployee-navtab.component.css']
})
export class ParemployeeNavtabComponent implements OnInit {
  public role: any;
  public employeeId: any;
  public empID: any;
  getAllPAREmployeeDataById: any = [];
  activeTab: any;
  emp_id;
  navTabs = ['Employee Summary', 'Documents'];
  clientNavTabs = ['Employee Summary', 'Requirements'];
  clientHidden: boolean = false;
  constructor(private parEmployeeService: ParEmployeeService, private router: Router, public activatedRoute: ActivatedRoute) { }
  ngOnInit() {
    let roleVal = parseInt(localStorage.getItem("RoleVal"));
    this.role = localStorage.getItem("Role")
    this.employeeId = localStorage.getItem("dbId");
    this.empID = localStorage.getItem("ParEmployeeID");
    this.emp_id = localStorage.getItem('Employee_Id');
    if (roleVal === 8) {
      this.clientHidden = true;
      this.getClientParEmployeeDetails();
    } else {
      this.clientHidden = false;
      this.getParEmployeeDetails();
    }
    if (this.activatedRoute.snapshot.params["docType"] !== undefined && this.activatedRoute.snapshot.params["docType"] !== '') {
      if (this.activatedRoute.snapshot.params["docType"] === 'EmployeeSummary')
        this.activeTab = 'Employee Summary';
      else if (this.activatedRoute.snapshot.params["docType"] === 'Requirements' && this.role == 'PC Client')
        this.activeTab = 'Requirements';
      else if (this.activatedRoute.snapshot.params["docType"] === 'Documents' && this.role !== 'PC Client')
        this.activeTab = 'Documents';
    }

  }

  selectedTab(tab) {
    let roleVal = parseInt(localStorage.getItem("RoleVal"));
    this.emp_id = localStorage.getItem('Employee_Id');
    if (roleVal === 8) {
      if (tab === 'Employee Summary') {
        this.activeTab = 'Employee Summary';
        this.router.navigate(['par/employee', 'EmployeeSummary', this.emp_id]);
      }
      else if (tab === 'Requirements') {
        this.activeTab = 'Requirements';
        this.router.navigate(['par/employee', 'Requirements', this.emp_id]);
      }
    } else {
      if (tab === 'Employee Summary') {
        this.activeTab = 'Employee Summary';
        this.router.navigate(['par/employee', 'EmployeeSummary', this.empID]);
      }
      else if (tab === 'Documents') {
        this.activeTab = 'Documents';
        this.router.navigate(['par/employee', 'Documents', this.empID]);
      }
    }

  }

  getParEmployeeDetails() {
    this.parEmployeeService.getParEmployeeBy_Id(this.employeeId).subscribe(res => {
      this.getAllPAREmployeeDataById = res.Employees[0];
    });
  }
  getClientParEmployeeDetails() {
    this.parEmployeeService.getParEmployeeBy_Id(this.emp_id).subscribe(res => {
      this.getAllPAREmployeeDataById = res.Employees[0];
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/paremployee-navtab/paremployee-navtab.component.ts